// extracted by mini-css-extract-plugin
export default {"fileDrop":"fileDrop_fileDrop__AoTvx","imageWrapper":"fileDrop_imageWrapper__SzWQA","close":"fileDrop_close__O7B1D","fileDropWrapperBorder":"fileDrop_fileDropWrapperBorder__q03tp"};